import React, { Component } from "react";
import DashSearchHeader from "../../part/header.search.dashboard";
import TutorDashMenu from "../../part/tutor_dash_menu";
import FooterDashboard from "../../part/footer.dashboard";
import ReactQuill from "react-quill";
import ThumbnailUpload from "../../part/thumbnailUpload";
import { CiEdit } from "react-icons/ci";
import { AiOutlineDelete } from "react-icons/ai";
// import { FaRegSquare } from "react-icons/fa";
import UploadFile from "../../part/uploadFile";
import ZipUpload from "../../part/zipFileUpload";
import "../../app.css"
import { Link } from "react-router-dom";
import axios from "axios";


// Configuration for the Quill editor toolbar
const QuillModules = {
    toolbar: [
        // Headers, lists, and text styles
        [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
        [{ size: [] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],

        // Alignment, links, and media
        [{ 'align': [] }],
        ['link', 'image', 'video'],

        // Cleanup and code
        ['clean'],
        ['code-block']
    ],
};

// Configuration for formats to be allowed (important for copy/paste from Word/HTML)
const QuillFormats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video', 'align', 'code-block'
];



class TutorCourseEdit extends React.Component {
    state = {
        menuCoverWidth: this.getInitialMenuCoverWidth(),
        windowHeight: window.innerHeight - 60,
        user: {
            name: '',
            email: '',
            role: ''
        },
        labels: "",
        tags: "",
        durations: [{ from: '', to: '' }],
        sections: [],
        package: [],
        thumbnail: null,
        SEOtags: [],
        tagInput: "",
        loading: false,
        isExamChanged: false

    }
    quillInstances = {};

    getInitialMenuCoverWidth() {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);

        if (this.props.id) {
            // this.fetchCourseData(this.props.id);
            console.log("course id", this.props.id)
        }
        // const storedUser = localStorage.getItem('user');

        // if (storedUser) {
        //   try {
        //     const user = JSON.parse(storedUser);

        //     if (user && user.role === 'student') {
        //       window.location.href = '/dashboard';
        //     } else {
        //      this.setState({user:user})
        //     }

        //   } catch (error) {
        //     console.error("Error parsing user data:", error);
        //     localStorage.removeItem('user');
        //     window.location.href = '/login'; // Redirect to login on error
        //   }
        // }
    }

    handleResize = () => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            this.setState({ menuCoverWidth: menuCover.offsetWidth });
        }
        this.setState({ windowHeight: window.innerHeight - 60 });
    };




    handleInput = (event) => {
        const { name, value, type, checked } = event.target
        if (type === 'checkbox') {
            const updatedPackageOptions = [...this.state.package];

            if (checked) {
                if (!updatedPackageOptions.includes(value)) {
                    updatedPackageOptions.push(value);
                }
            } else {
                const index = updatedPackageOptions.indexOf(value);
                if (index > -1) {
                    updatedPackageOptions.splice(index, 1);
                }
            }
            this.setState({ package: updatedPackageOptions });
        } else {
            this.setState({
                [name]: value
            })
        }
    }

    handleDescriptionChange = (content, delta, source, editor) => {
        this.setState({
            description: content
        });
    };

    handleQuillChange = (field) => (content) => {
        this.setState({
            [field]: content
        });
    };

    handleThumbnailUpdate = (file) => {
        this.setState({ thumbnail: file });
    };
    handleVideoUpdate = (file) => {
        this.setState({ video: file });
    };
    handleDocumentUpdate = (file) => {
        this.setState({ document: file });
    };
    handleZipUpdate = (file) => {
        this.setState({ learningToolZip: file });
    };


    // this is for duration


    addDuration = () => {
        this.setState((prevState) => ({
            durations: [...prevState.durations, { from: '', to: '' }]
        }));
    };

    handleDurationChange = (index, field, value) => {
        const updatedDurations = [...this.state.durations];
        updatedDurations[index][field] = value;
        this.setState({ durations: updatedDurations });
    };
    removeDuration = (index) => {
        this.setState((prevState) => ({
            // Keep only durations that DON'T match the clicked index
            durations: prevState.durations.filter((_, i) => i !== index)
        }));
    };




    // this is for the scetion and modules
    // SECTION LOGIC
    // addSection = () => {
    //     if (!this.state.newSectionTitle.trim()) return;
    //     const newSection = {
    //         title: this.state.newSectionTitle,
    //         isEditing: false,
    //         // Ensure thumbnail is included here
    //         modules: [{ title: '', video: null, document: null, zip: null, thumbnail: null }]
    //     };
    //     this.setState(prevState => ({
    //         sections: [...prevState.sections, newSection],
    //         newSectionTitle: ''
    //     }));
    // };

    addSection = () => {
        if (!this.state.newSectionTitle.trim()) return;
        const newSection = {
            title: this.state.newSectionTitle,
            isEditing: false,
            modules: [{ title: '', video: null, document: null, zip: null, thumbnail: null }],
            exam: null // Initialize with no exam
        };
        this.setState(prevState => ({
            sections: [...prevState.sections, newSection],
            newSectionTitle: ''
        }));
    };

    deleteSection = (sIndex) => {
        this.setState({ sections: this.state.sections.filter((_, i) => i !== sIndex) });
    };

    toggleSectionEdit = (sIndex) => {
        const sections = [...this.state.sections];
        sections[sIndex].isEditing = !sections[sIndex].isEditing;
        this.setState({ sections });
    };

    handleSectionTitleChange = (sIndex, value) => {
        const sections = [...this.state.sections];
        sections[sIndex].title = value;
        this.setState({ sections });
    };

    // MODULE LOGIC
    addModule = (sIndex) => {
        const sections = [...this.state.sections];
        // Add thumbnail: null here
        sections[sIndex].modules.push({ title: '', video: null, document: null, zip: null, thumbnail: null });
        this.setState({ sections });
    };

    deleteModule = (sIndex, mIndex) => {
        const sections = [...this.state.sections];
        sections[sIndex].modules = sections[sIndex].modules.filter((_, i) => i !== mIndex);
        this.setState({ sections });
    };

    handleModuleChange = (sIndex, mIndex, field, value) => {
        const sections = [...this.state.sections];
        sections[sIndex].modules[mIndex][field] = value;
        this.setState({ sections });
    };



    //this is for each section exam
    addExam = (sIndex) => {
        const sections = [...this.state.sections];
        // Create the exam object for this specific section
        sections[sIndex].exam = { title: '', instruction: '', time: 0, pass_score: 0 };
        this.setState({ sections });
    };

    deleteExam = (sIndex) => {
        const sections = [...this.state.sections];
        // Remove the exam object
        sections[sIndex].exam = null;
        this.setState({ sections });
    };

    handleExamInput = (sIndex, field, value) => {
        const sections = [...this.state.sections];
        sections[sIndex].exam[field] = value;
        this.setState({ sections, isExamChanged: true });
    };






    // tag for the seo configuration
    handleTagInput = (event) => {
        const { value } = event.target;

        // Check if the input contains at least one comma
        if (value.includes(",")) {
            // 1. Split the string by commas
            const potentialTags = value.split(",");

            // 2. The last element in the array is what the user is currently typing 
            // (if it doesn't end with a comma). 
            // Everything before the last comma is a completed tag.
            const newTagsToAdd = potentialTags
                .slice(0, -1) // Take everything except the last part
                .map(tag => tag.trim()) // Remove whitespace
                .filter(tag => tag !== "" && !this.state.SEOtags.includes(tag)); // Remove empty or duplicates

            const remainingInput = potentialTags[potentialTags.length - 1];

            if (newTagsToAdd.length > 0) {
                this.setState({
                    SEOtags: newTagsToAdd,
                    tagInput: remainingInput // Keep the unfinished part in the input
                });
            } else {
                // If no new unique tags were found, just update the input text
                this.setState({
                    tagInput: value
                });
            }
        } else {
            // Normal typing (no comma yet)
            this.setState({
                tagInput: value
            });
        }
    };

    handleKeyDown = (event) => {
        // Add tag on Enter or Tab
        if (event.key === 'Enter' || event.key === 'Tab') {
            event.preventDefault();
            const value = this.state.tagInput.trim();

            if (value && !this.state.tags.includes(value)) {
                this.setState({
                    SEOtags: value,
                    tagInput: ""
                });
            }
        }
    };

    handleAddTag = () => {
        const blog = this.state;
        const newTag = blog.tagInput.trim();

        if (newTag && !blog.SEOtags.includes(newTag)) {
            this.setState((prevState) => ({
                SEOtags: [...prevState.SEOtags, newTag],
                tagInput: "" // Clear the input field

            }));
        }
    };

    handleRemoveTag = (tagToRemove) => {
        this.setState({
            SEOtags: this.state.SEOtags.filter(tag => tag !== tagToRemove),

        });
    };








    // getAuthHeaders = () => {
    //     const token = localStorage.getItem('accessToken');
    //     return {
    //         headers: {
    //             'Authorization': `Bearer ${token}`,
    //             'Content-Type': 'multipart/form-data'
    //         }
    //     };
    // };


    // fetchCourseData = async (id) => {
    //     this.setState({ loading: true })
    //     try {
    //         const config = this.getAuthHeaders();
    //         const response = await axios.get(`YOUR_API_ENDPOINT/${id}`, config);
    //         const data = response.data;


    //         const mappedSections = (data.sections || []).map(section => ({
    //             ...section,
    //             title: section.title || '',
    //             isEditing: false,
    //             // Ensure exam is present, or null if missing from API
    //             exam: section.exam ? {
    //                 title: section.exam.title || '',
    //                 instruction: section.exam.instruction || '',
    //                 time: section.exam.time || 0,
    //                 pass_score: section.exam.pass_score || 0
    //             } : null,
    //             modules: (section.modules || []).map(mod => ({
    //                 ...mod,
    //                 title: mod.title || '',
    //                 video: mod.video || null,
    //                 document: mod.document || null,
    //                 zip: mod.zip || null,
    //                 thumbnail: mod.thumbnail || null
    //             }))
    //         }));

    //         // Map the API response to your state keys
    //         this.setState({
    //             title: data.title || '',
    //             description: data.description || '',
    //             price: data.price || '',
    //             training_type: data.training_type || '',
    //             package: data.package || [],
    //             labels: data.labels || "",
    //             tags: data.tags || "",
    //             durations: data.durations || [{ from: '', to: '' }],
    //             sections: data.sections || [],
    //             // Note: Thumbnails/Files usually come back as URLs from the API
    //             existingThumbnail: data.course_thumbnail,
    //             loading: false,
    //             // sections: mappedSections,
    //         });
    //     } catch (error) {
    //         console.error("Error fetching course data:", error);
    //         alert("Failed to load course data.");
    //         this.setState({ loading: false })
    //     }
    // };


    // handleSubmit = async () => {
    //     const { id } = this.props;
    //     const { title, description, sections, thumbnail, price, training_type, tags, durations, package: pkg } = this.state;
    //     this.setState({ loading: true })
    //     const formData = new FormData();

    //     // Basic fields
    //     formData.append('title', title);
    //     formData.append('description', description);
    //     formData.append('price', price);
    //     formData.append('training_type', training_type);
    //     formData.append('tags', JSON.stringify(tags));
    //     formData.append('durations', JSON.stringify(durations));
    //     formData.append('package', JSON.stringify(pkg));

    //     // Only append thumbnail if a NEW one was selected
    //     if (thumbnail instanceof File) {
    //         formData.append('course_thumbnail', thumbnail);
    //     }

    //     // Sections and Modules
    //     sections.forEach((section, sIdx) => {
    //         formData.append(`sections[${sIdx}][title]`, section.title);

    //         // --- NEW: Handle Exam Data ---
    //         if (section.exam) {
    //             formData.append(`sections[${sIdx}][exam][title]`, section.exam.title);
    //             formData.append(`sections[${sIdx}][exam][instruction]`, section.exam.instruction);
    //             formData.append(`sections[${sIdx}][exam][time]`, section.exam.time);
    //             formData.append(`sections[${sIdx}][exam][pass_score]`, section.exam.pass_score);
    //         }

    //         section.modules.forEach((module, mIdx) => {
    //             formData.append(`sections[${sIdx}][modules][${mIdx}][title]`, module.title);
    //             if (module.video instanceof File) formData.append(`module_video_${sIdx}_${mIdx}`, module.video);
    //             if (module.document instanceof File) formData.append(`module_doc_${sIdx}_${mIdx}`, module.document);
    //             if (module.zip instanceof File) formData.append(`module_zip_${sIdx}_${mIdx}`, module.zip);
    //             if (module.thumbnail instanceof File) formData.append(`module_thumb_${sIdx}_${mIdx}`, module.thumbnail);
    //         });
    //     });

    //     try {
    //         const config = this.getAuthHeaders();
    //         let response;
    //         if (id) {
    //             // UPDATE MODE (PATCH)
    //             response = await axios.patch(`YOUR_API_ENDPOINT/${id}`, formData, config);
    //             alert("Course updated successfully!");
    //              this.setState({ isExamChanged: false });
    //             // We do NOT clear the state here so the user can keep editing
    //         } else {
    //             // CREATE MODE (POST)
    //             response = await axios.post('YOUR_API_ENDPOINT', formData, config);
    //             alert("Course created successfully!");
    //             this.resetForm(); // Clear inputs for new entry
    //         }
    //         this.setState({ loading: false })
    //     } catch (error) {
    //         console.error("Operation failed:", error);
    //         alert("An error occurred while saving.");
    //         this.setState({ loading: false })
    //     }
    // }

    // // Helper to clear form after creation
    // resetForm = () => {
    //     this.setState({
    //         title: '',
    //         description: '',
    //         price: '',
    //         training_type: '',
    //         durations: [{ from: '', to: '' }],
    //         sections: [],
    //         package: [],
    //         thumbnail: null,
    //         tags: [],
    //         tagInput: "",
    //         loading: false
    //     });
    // };














    //     handleSubmit = async () => {
    //     const { title, description, sections, thumbnail, price, training_type, tags, durations, package: pkg } = this.state;

    //     const formData = new FormData();

    //     // Append basic fields
    //     formData.append('title', title);
    //     formData.append('description', description);
    //     formData.append('price', price);
    //     formData.append('training_type', training_type);
    //     formData.append('course_thumbnail', thumbnail); // Main course thumbnail
    //     formData.append('tags', JSON.stringify(tags));
    //     formData.append('durations', JSON.stringify(durations));
    //     formData.append('package', JSON.stringify(pkg));

    //     // Append Sections and Modules
    //     // Note: When sending files in nested arrays, it's often best to append files 
    //     // with a unique key naming convention that your backend can parse.
    //     sections.forEach((section, sIdx) => {
    //         formData.append(`sections[${sIdx}][title]`, section.title);

    //         section.modules.forEach((module, mIdx) => {
    //             formData.append(`sections[${sIdx}][modules][${mIdx}][title]`, module.title);

    //             // Append the actual Files
    //             if (module.video) formData.append(`module_video_${sIdx}_${mIdx}`, module.video);
    //             if (module.document) formData.append(`module_doc_${sIdx}_${mIdx}`, module.document);
    //             if (module.zip) formData.append(`module_zip_${sIdx}_${mIdx}`, module.zip);
    //             if (module.thumbnail) formData.append(`module_thumb_${sIdx}_${mIdx}`, module.thumbnail);
    //         });
    //     });

    //     // Example API Call
    //     try {
    //         const response = await fetch('YOUR_API_ENDPOINT', {
    //             method: 'POST',
    //             body: formData,
    //             // Do NOT set Content-Type header; the browser will set it to 
    //             // multipart/form-data with the correct boundary automatically.
    //         });
    //         const result = await response.json();
    //         console.log("Success:", result);
    //     } catch (error) {
    //         console.error("Upload failed:", error);
    //     }
    // }




    render() {
        const { menuCoverWidth, loading } = this.state;
        console.log(this.state)
        return (
            <div className="dashboard">
                <DashSearchHeader />
                <TutorDashMenu />
                <div className="dash_body tutor" style={{ width: `calc(100% - ${menuCoverWidth}px - 8px)` }} >
                    <div className="course_edit_cover">
                        <div className="course_edit_contain">
                            <h2>{this.props.id ? `Update Course : ${this.props.id}` : "Add Course"} {this.props.id ? <Link to="/tutor_course_edit"><button>Add Course</button></Link> : <Link to="/tutor_courses"><button>Back</button></Link>}</h2>
                            <p>Review all instructions and save your work before
                                leaving this page to avoid losing any progress.</p>
                            <div className="course_edit_space">
                                <div className="left">
                                    <div className="course_edit_space">
                                        <div className="course_edit_input full">
                                            <label>Title</label>
                                            <input type="text" name="title" value={this.state.title} onChange={this.handleInput} placeholder="Input course title" required />
                                        </div>
                                    </div>
                                    <div className="course_edit_space">
                                        <div className="course_edit_input full">
                                            <label>Description</label>
                                            <div style={{ backgroundColor: 'white', borderRadius: "5px" }} className="quill_div_height"> {/* Wrapper for background */}
                                                <ReactQuill
                                                    ref={(el) => (this.quillInstances['description'] = el)}
                                                    theme="snow"
                                                    value={this.state.description || ''}
                                                    onChange={this.handleQuillChange("description")}
                                                    modules={QuillModules}
                                                    formats={QuillFormats}
                                                    style={{ height: '200px', marginBottom: '50px', border: "none" }} // Height + space for toolbar/bottom
                                                    placeholder="Write about the course..."
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="right">
                                    <div className="course_edit_space">
                                        <div className="course_edit_input full">
                                            <label>Thumbnails</label>
                                            {/* <div className="thumbnail_cover">
                                                <div className="thumbnail_contain">
                                                    { image ?
                                                    <>
                                                    <img />
                                                    <button>Re-Upload</button>
                                                    <button>Cancle</button>
                                                    </>:
                                                    <>
                                                    <IoCloudUploadOutline />
                                                    <p>Drop a file or click to upload</p>
                                                    <button>Upload Image</button>
                                                    </>
                                                    }
                                                </div>
                                            </div> */}
                                            <ThumbnailUpload initialImage={this.state.thumbnail} onFileSelect={this.handleThumbnailUpdate} />
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div className="course_edit_space">
                                <div className="course_edit_input">
                                    <label>Course Label</label>
                                    <select name="labels" id='labels' value={this.state.labels} onChange={this.handleInput} required>
                                        <option value="">Select Course Label</option>
                                        <option value="GIS">GIS</option>
                                        <option value="Drone">Drone</option>
                                        <option value="Remote Sensing">Remote Sensing</option>
                                        <option value="Survey">Survey</option>
                                        <option value="Mapping">Mapping</option>
                                        <option value="Engineering">Engineering</option>
                                        <option value="Geo Programming">Geo Programming</option>
                                        <option value="Event">Event (Summit/Workshop/Conference)</option>
                                        <option value="Webinar">Webinar</option>
                                        <option value="Podcast">Podcast</option>
                                    </select>
                                </div>
                                <div className="course_edit_input">
                                    <label>Course Tag</label>
                                    <select name="tags" id='tags' value={this.state.tags} onChange={this.handleInput} required>
                                        <option value="">Select Course Tag</option>
                                        <option value="Beginner">Beginner</option>
                                        <option value="Intermediate">Intermediate</option>
                                        <option value="Advance">Advance</option>
                                        <option value="Professional">Professional</option>
                                        <option value="Beginner to Intermediate">Beginner to Intermediate</option>
                                        <option value="Beginner to Advance">Beginner to Advance</option>
                                        <option value="Beginner to Professional">Beginner to Professional</option>
                                    </select>
                                </div>
                            </div>

                            <div className="course_edit_space">
                                <div className="course_edit_input full">
                                    <label>Course Package</label>
                                    <div className="course_edit_grid">
                                        <label className="main"><input type="checkbox" name="software" value="Software" onChange={this.handleInput} checked={this.state.package.includes("Software")} /> Software</label>
                                        <label className="main"><input type="checkbox" name="data" value="Data" onChange={this.handleInput} checked={this.state.package.includes("Data")} /> Data</label>
                                        <label className="main"><input type="checkbox" name="manual" value="Manual" onChange={this.handleInput} checked={this.state.package.includes("Manual")} /> Manual</label>
                                        <label className="main"><input type="checkbox" name="jotter" value="Jotter" onChange={this.handleInput} checked={this.state.package.includes("Jotter")} /> Jotter</label>
                                        <label className="main"><input type="checkbox" name="field" value="Field Experience" onChange={this.handleInput} checked={this.state.package.includes("Field Experience")} /> Field Experience</label>
                                        <label className="main"><input type="checkbox" name="practical" value="100% Practical" onChange={this.handleInput} checked={this.state.package.includes("100% Practical")} /> 100% Practical</label>
                                        <label className="main"><input type="checkbox" name="consultation" value="Free Consultation" onChange={this.handleInput} checked={this.state.package.includes("Free Consultation")} /> Free Consultation</label>
                                        <label className="main"><input type="checkbox" name="exam" value="Exam and Certificate" onChange={this.handleInput} checked={this.state.package.includes("Exam and Certificate")} /> Exam and Certificate</label>
                                        <label className="main"><input type="checkbox" name="internship" value="Free internship" onChange={this.handleInput} checked={this.state.package.includes("Free internship")} /> Free internship</label>
                                        <label className="main"><input type="checkbox" name="opportunities" value="Access job opportunities" onChange={this.handleInput} checked={this.state.package.includes("Access job opportunities")} /> Access job opportunities</label>
                                    </div>
                                </div>
                            </div>


                            <div className="course_edit_space">
                                <div className="course_edit_input">
                                    <label>Course Price</label>
                                    <input type="number" name="price" value={this.state.price} onChange={this.handleInput} required />
                                </div>
                                <div className="course_edit_input">
                                    <label>Training Type</label>
                                    <select type="text" name="training_type" value={this.state.training_type} onChange={this.handleInput}>
                                        <option value="">Select Training Type</option>
                                        <option value="Online Prerecorded">Online Prerecorded</option>
                                        <option value="Online Live with Facilitator">Online Live with Facilitator</option>
                                        <option value="General Physical Class">General Physical Class</option>
                                        <option value="Physical Private Class">Physical Private Class</option>
                                    </select>
                                </div>
                            </div>

                            {/* <div className="course_edit_space">
                                <div className="course_edit_input">
                                    <label>Duration - From </label>
                                    <input type="date" />
                                </div>
                                <div className="course_edit_input">
                                    <label>Duration - To</label>
                                    <input type="date" />
                                </div>
                            </div>
                            <div className="course_edit_space">
                                <div className="course_edit_input full">
                                    <p>Click the button below to add another duration</p>
                                    <button className="add">+ Add duration</button>
                                </div>
                            </div> */}
                            {this.state.durations.map((duration, index) => (
                                <div style={{ flexDirection: "column" }} key={index}>
                                    <div className="course_edit_space" key={index} >
                                        <div className="course_edit_input">
                                            <label>Duration - From </label>
                                            <input
                                                type="date"
                                                value={duration.from}
                                                onChange={(e) => this.handleDurationChange(index, 'from', e.target.value)}
                                            />
                                        </div>
                                        <div className="course_edit_input">
                                            <label>Duration - To</label>
                                            <input
                                                type="date"
                                                value={duration.to}
                                                onChange={(e) => this.handleDurationChange(index, 'to', e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    {this.state.durations.length > 1 && (
                                        <div className="course_edit_space">
                                            <div className="course_edit_input full">
                                                <button
                                                    onClick={() => this.removeDuration(index)}
                                                    style={{ color: 'red', cursor: 'pointer', margin: "10px 0px", backgroundColor: "White" }}
                                                    title="Remove Duration"
                                                    className="add"
                                                >
                                                    <AiOutlineDelete /> Remove
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            ))}

                            <div className="course_edit_space">
                                <div className="course_edit_input full">
                                    <p>Click the button below to add another duration</p>
                                    <button className="add" onClick={this.addDuration}>+ Add duration</button>
                                </div>
                            </div>




                            <h3 style={{ marginTop: "20px" }}>Course Content</h3>
                            <p>You are to create a course content which will enable you to create a modules in which you can add video, document or files attached to them. </p>

                            {/* <div style={{ backgroundColor: "white", borderRadius: "5px", padding: "10px 0px" }}>
                                <div className="course_edit_input full">
                                    <div className="course_edit_space">
                                        <input type="text" disabled value="Introduction to GIS" />
                                        <CiEdit className="icon" />
                                        <AiOutlineDelete className="icon" />
                                    </div>
                                </div>


                                <div className="course_edit_space">
                                    <div className="course_edit_input full">
                                        <div className="course_edit_space">
                                            <FaRegSquare className="icon"/>
                                            <input type="text" disabled value="Introduction to GIS" />
                                            <CiEdit className="icon" />
                                            <AiOutlineDelete className="icon" />
                                        </div>
                                        <div className="course_edit_space">
                                            <div className="course_edit_input three">
                                                <label>Video</label>
                                                <ThumbnailUpload initialImage={image} onFileSelect={this.handleThumbnailUpdate}/>
                                            </div>
                                            <div className="course_edit_input three">
                                                <label>Document</label>
                                                <ThumbnailUpload initialImage={image} onFileSelect={this.handleThumbnailUpdate}/>
                                            </div>
                                            <div className="course_edit_input three">
                                                <label>File</label>
                                                <ThumbnailUpload initialImage={image} onFileSelect={this.handleThumbnailUpdate}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                

                            </div> */}



                            {/* <div className="course_edit_space">
                                <input type="text" placeholder="Write your content here (e.g Section 1.0 : Introduction to GIS) " />
                                <button className="add" style={{ width: "150px", height: "40px", borderRadius: "5px" }}>Add Content</button>
                            </div>

                            <div style={{ backgroundColor: "white", borderRadius: "5px", border: "1px solid white" }}>
                                <div className="course_edit_input full" style={{ padding: "12px 0px" }}>
                                    <div className="course_edit_space">
                                        <input type="text" disabled value="Introduction to GIS" />
                                        <CiEdit className="icon" />
                                        <AiOutlineDelete className="icon" />
                                    </div>
                                </div>

                                <div style={{ backgroundColor: "rgb(237, 243, 248)", borderRadius: "5px", padding: "10px 0px" }}>

                                    <div style={{ borderRadius: "5px", border: "1px solid white", margin: "10px 0px" }}>
                                        <div className="course_edit_input full" style={{ padding: "12px 0px" }}>
                                            <div className="course_edit_space">
                                                <input type="text" placeholder="Module 1: Introduction to GIS" />
                                                <AiOutlineDelete className="icon" />
                                            </div>
                                        </div>

                                        <div className="course_edit_space">
                                            <div className="course_edit_input three">
                                                <UploadFile type="video" onFileSelect={this.handleVideoUpdate} />
                                            </div>
                                            <div className="course_edit_input three">
                                                <UploadFile type="document" onFileSelect={this.handleDocumentUpdate} />
                                            </div>
                                            <div className="course_edit_input three">
                                                <UploadFile type="zip" onFileSelect={this.handleZipUpdate} />
                                            </div>
                                        </div>

                                    </div>

                                    <div style={{ borderRadius: "5px", border: "1px solid white", margin: "10px 0px" }}>
                                        <div className="course_edit_input full" style={{ padding: "12px 0px" }}>
                                            <div className="course_edit_space">
                                                <input type="text" placeholder="Module 1: Introduction to GIS" />
                                                <AiOutlineDelete className="icon" />
                                            </div>
                                        </div>

                                        <div className="course_edit_space">
                                            <div className="course_edit_input three">
                                                <UploadFile type="video" onFileSelect={this.handleVideoUpdate} />
                                            </div>
                                            <div className="course_edit_input three">
                                                <UploadFile type="document" onFileSelect={this.handleDocumentUpdate} />
                                            </div>
                                            <div className="course_edit_input three">
                                                <UploadFile type="zip" onFileSelect={this.handleZipUpdate} />
                                            </div>
                                        </div>

                                    </div>

                                    <div className="course_edit_space">
                                        <div className="course_edit_input full" >
                                            <button className="add"> + Add Modules</button>
                                        </div>
                                    </div>
                                </div>
                            </div> */}


                            <div className="course_edit_space" >
                                <input
                                    type="text"
                                    placeholder="Write your content here (e.g Section 1.0 : Introduction to GIS)"
                                    value={this.state.newSectionTitle}
                                    onChange={(e) => this.setState({ newSectionTitle: e.target.value })}
                                />
                                <button
                                    className="add"
                                    style={{ width: "150px", height: "40px", borderRadius: "5px" }}
                                    onClick={this.addSection}
                                >
                                    Add Content
                                </button>
                            </div>

                            {/* 2. List of Sections and their Modules */}
                            {this.state.sections.map((section, sIndex) => (
                                <div key={sIndex} style={{ backgroundColor: "white", borderRadius: "5px", border: "1px solid white", marginBottom: '20px' }}>

                                    {/* Section Header */}
                                    <div className="course_edit_input full" style={{ padding: "12px 0px" }}>
                                        <div className="course_edit_space" style={{ flexDirection: "unset" }}>
                                            <input
                                                type="text"
                                                disabled={!section.isEditing}
                                                value={section.title}
                                                onChange={(e) => this.handleSectionTitleChange(sIndex, e.target.value)}
                                                style={{ border: section.isEditing ? '1px solid #ccc' : 'none' }}
                                            />
                                            <CiEdit className="icon" onClick={() => this.toggleSectionEdit(sIndex)} style={{ cursor: 'pointer' }} />
                                            <AiOutlineDelete className="icon" onClick={() => this.deleteSection(sIndex)} style={{ cursor: 'pointer', color: 'red' }} />
                                        </div>
                                    </div>

                                    {/* Modules Container */}
                                    <div style={{ backgroundColor: "rgb(237, 243, 248)", borderRadius: "5px", padding: "10px 0px" }}>
                                        {section.modules.map((module, mIndex) => (
                                            <div key={mIndex} style={{ borderRadius: "5px", border: "1px solid white", margin: "10px 10px" }}>
                                                <div className="course_edit_input full" style={{ padding: "12px 0px" }}>
                                                    <div className="course_edit_space" style={{ flexDirection: "unset" }}>
                                                        <input
                                                            type="text"
                                                            placeholder="Module title (e.g Module 1: Basics)"
                                                            value={module.title}
                                                            onChange={(e) => this.handleModuleChange(sIndex, mIndex, 'title', e.target.value)}
                                                        />
                                                        <AiOutlineDelete
                                                            className="icon"
                                                            onClick={() => this.deleteModule(sIndex, mIndex)}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="course_edit_space grid">
                                                    <div className="course_edit_input three">
                                                        <UploadFile type="video" onFileSelect={(file) => this.handleModuleChange(sIndex, mIndex, 'video', file)} />
                                                    </div>
                                                    <div className="course_edit_input three">
                                                        <UploadFile type="document" onFileSelect={(file) => this.handleModuleChange(sIndex, mIndex, 'document', file)} />
                                                    </div>
                                                    <div className="course_edit_input three">
                                                        <UploadFile type="zip" onFileSelect={(file) => this.handleModuleChange(sIndex, mIndex, 'zip', file)} />
                                                    </div>
                                                    <div className="course_edit_input three">
                                                        <UploadFile type="image" label="Module Thumb" onFileSelect={(file) => this.handleModuleChange(sIndex, mIndex, 'thumbnail', file)} />
                                                    </div>
                                                </div>

                                            </div>
                                        ))}


                                        {section.exam && (
                                            <div style={{ margin: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }}>
                                                <h3 style={{ marginTop: "10px", marginBottom: "10px" }}>Create Exam</h3>
                                                <div className="course_edit_space">
                                                    <div className="course_edit_input full">
                                                        <label>Title</label>
                                                        <input
                                                            type="text"
                                                            value={section.exam.title}
                                                            onChange={(e) => this.handleExamInput(sIndex, 'title', e.target.value)}
                                                            placeholder="Input exam title" required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="course_edit_space" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                    <div className="course_edit_input full">
                                                        <label>Instruction</label>
                                                        <input
                                                            type="text"
                                                            value={section.exam.instruction}
                                                            onChange={(e) => this.handleExamInput(sIndex, 'instruction', e.target.value)}
                                                            placeholder="Input exam instruction" required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="course_edit_space">
                                                    <div className="course_edit_input">
                                                        <label>Exam Time</label>
                                                        <input
                                                            type="number"
                                                            value={section.exam.time}
                                                            onChange={(e) => this.handleExamInput(sIndex, 'time', e.target.value)} required
                                                        />
                                                    </div>
                                                    <div className="course_edit_input">
                                                        <label>Pass Score</label>
                                                        <input
                                                            type="number"
                                                            value={section.exam.pass_score}
                                                            onChange={(e) => this.handleExamInput(sIndex, 'pass_score', e.target.value)} required
                                                        />
                                                    </div>
                                                </div>
                                                {this.props.id && section.exam && !this.state.isExamChanged && (
                                                    <div className="course_edit_space" style={{ padding: "0 10px" }}>
                                                        <div className="course_edit_input">
                                                            <button
                                                                className="add"
                                                                style={{ backgroundColor: "#28a745", color: "white" }}
                                                                onClick={() => window.location.href = `/admin/exam-questions/${section.exam.id}`}
                                                            >
                                                                + Add questions
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* Add Module Button */}
                                        <div className="course_edit_space" style={{ padding: "0 10px" }}>
                                            <div className="course_edit_input">
                                                <button className="add" onClick={() => this.addModule(sIndex)}> + Add Module</button>
                                            </div>
                                            <div className="course_edit_input">
                                                {section.exam ? (
                                                    <button
                                                        className="add"
                                                        onClick={() => this.deleteExam(sIndex)}
                                                        style={{ backgroundColor: "red", color: "white" }}
                                                    >
                                                        - Delete Exam
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="add"
                                                        onClick={() => this.addExam(sIndex)}
                                                        style={{ backgroundColor: "rgb(20,107,217)", color: "white" }}
                                                    >
                                                        + Add Exam
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}




                            <h3 style={{ marginTop: "20px" }}>Additional Information</h3>
                            <p>More data to improve the student experience </p>

                            <div className="course_edit_space">
                                <div className="left">
                                    <div className="course_edit_space">
                                        <div className="course_edit_input full">
                                            <label>Learning Tool Description</label>
                                            <div style={{ backgroundColor: 'white', borderRadius: "5px" }} className="quill_div_height"> {/* Wrapper for background */}
                                                <ReactQuill
                                                    ref={(el) => (this.quillInstances['learningTool'] = el)}
                                                    theme="snow"
                                                    value={this.state.learningTool || ''}
                                                    onChange={this.handleQuillChange("learningTool")}
                                                    modules={QuillModules}
                                                    formats={QuillFormats}
                                                    style={{ height: '200px', marginBottom: '50px', border: "none" }} // Height + space for toolbar/bottom
                                                    placeholder="Write a note on the Learning tool ..."
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="right">
                                    <div className="course_edit_space">
                                        <div className="course_edit_input full">
                                            <label>ZIP File </label>
                                            <ZipUpload initialFileName={this.state.learningToolZip} onFileSelect={this.handleZipUpdate} height="250px" />
                                            {/* UploadFile type="zip" onFileSelect={(file) => this.handleModuleChange(sIndex, mIndex, 'zip', file)}  */}
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div className="course_edit_space">
                                <div className="course_edit_input full">
                                    <label>Announcement</label>
                                    <div style={{ backgroundColor: 'white', borderRadius: "5px" }} className="quill_div_height"> {/* Wrapper for background */}
                                        <ReactQuill
                                            ref={(el) => (this.quillInstances['announcement'] = el)}
                                            theme="snow"
                                            value={this.state.announcement || ''}
                                            onChange={this.handleQuillChange("announcement")}
                                            modules={QuillModules}
                                            formats={QuillFormats}
                                            style={{ height: '200px', marginBottom: '50px', border: "none" }} // Height + space for toolbar/bottom
                                            placeholder="Write a note on the Learning tool ..."
                                        />
                                    </div>
                                </div>
                            </div>


                            <div className="course_edit_space">
                                <div className="course_edit_input full">
                                    <label>Notes</label>
                                    <div style={{ backgroundColor: 'white', borderRadius: "5px" }} className="quill_div_height"> {/* Wrapper for background */}
                                        <ReactQuill
                                            ref={(el) => (this.quillInstances['note'] = el)}
                                            theme="snow"
                                            value={this.state.note || ''}
                                            onChange={this.handleQuillChange("note")}
                                            modules={QuillModules}
                                            formats={QuillFormats}
                                            style={{ height: '200px', marginBottom: '50px', border: "none" }} // Height + space for toolbar/bottom
                                            placeholder="Write a note on the Learning tool ..."
                                        />
                                    </div>
                                </div>
                            </div>









                            <h3 style={{ marginTop: "20px" }}>SEO Information</h3>
                            <p>More data to improve the browser experience </p>


                            <div className="course_edit_space">
                                <div className="course_edit_input full">
                                    <label>Title</label>
                                    <input type="text" name="seo_title" value={this.state.seo_title} onChange={this.handleInput} placeholder="Input course seo title" required />
                                </div>
                            </div>

                            <div className="course_edit_space">
                                <div className="course_edit_input full">
                                    <label>Notes</label>
                                    <div style={{ backgroundColor: 'white', borderRadius: "5px" }} className="quill_div_height"> {/* Wrapper for background */}
                                        <ReactQuill
                                            ref={(el) => (this.quillInstances['seo_description'] = el)}
                                            theme="snow"
                                            value={this.state.seo_description || ''}
                                            onChange={this.handleQuillChange("seo_description")}
                                            modules={QuillModules}
                                            formats={QuillFormats}
                                            style={{ height: '200px', marginBottom: '50px', border: "none" }} // Height + space for toolbar/bottom
                                            placeholder="Write a short note on the course seo description..."
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="course_edit_space">
                                <div className="course_edit_input full">
                                    <label>Slug</label>
                                    <input type="text" name="slug" value={this.state.slug} onChange={this.handleInput} placeholder="course slug" required />
                                </div>
                            </div>

                            <div className="course_edit_space">
                                <div className="course_edit_input full">
                                    <label>Tag</label>
                                    <div className="course_edit_space">
                                        <input type="text" placeholder="Course tags should be inputed here" name="tagInput" id="tag" value={this.state.tagInput || ''} onChange={this.handleTagInput} onKeyDown={this.handleKeyDown} />
                                        <button className="add" style={{ width: "120px", height: "40px", borderRadius: "5px" }} type="button" onClick={this.handleAddTag} disabled={!this.state.tagInput || this.state.tagInput.trim().length === 0} >
                                            Add Tag
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="course_edit_space">
                                <div className="tag_container" style={{ width: "100%" }}>
                                    {this.state.SEOtags.map((tag, index) => (
                                        <button
                                            key={index}
                                            type="button"
                                            onClick={() => this.handleRemoveTag(tag)}
                                            style={{ margin: '5px', padding: '5px 10px', backgroundColor: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                                        >
                                            {tag} &nbsp; &times;
                                        </button>
                                    ))}
                                </div>
                            </div>






                            <div className="course_edit_space">
                                <div className="course_edit_input full">
                                    <button className="add" style={{ padding: "10px 0px" }} disabled={loading}>{loading ? "Loading ... " : this.props.id ? "Update Form" : "Submit Form"} </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <FooterDashboard />
                </div>
            </div>
        )
    }
}


export default TutorCourseEdit